import React from "react";
import "../../../../styles/Pages/Operational/Academic/Students/Students.style.css";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import StudentsPageHeaderCustom from "../../../../components/PagesComponents/Operational/Academic/Students/StudentsPageHeaderCustom.component";
import { ReactComponent as ArrowIcon } from "../../../../assets/Icons/Sidebar/ArrowDown.svg";
import { ReactComponent as FilterIcon } from "../../../../assets/Icons/Pages/Organizational/Management/Staffs/FilterIcon.svg";
import CardHeader from "../../../../components/Universal/CardHeader.component";
import StudentsDataTable from "../../../../components/PagesComponents/Operational/Academic/Students/StudentsTable.component";
import { Helmet } from "react-helmet";

import StudentsStore from "../../../../store/Academic/Students.store";

import SecondModal from "../../../../components/Universal/SecondModal.component";
const Body = ({
  classRepresentativeData,
  studentsData,
  genderWaysFilter,
  setGenderWaysFilter,
  exportToExcel,
}) => {
  const { studentBehaviorModal, setStudentBehaviorModal } = StudentsStore();

  return (
    <section className="studentsPage">
      <SecondModal
        isOpen={studentBehaviorModal}
        onClose={() => setStudentBehaviorModal()}
      >
        <div className="flex-col p-t-2 g-2">
          <button
            className="transparentCardBtn modalCloseBtn"
            onClick={setStudentBehaviorModal}
          >
            X
          </button>
          <h3 className="t-20 poppins weight-500 color-grayColor w-full text-align-center">
            Behavioral status
          </h3>
          <div className="flex-col">
            <ul className="behaviorModalContent">
              {["Security", "Manager", "Super"].map((role) => (
                <li key={role}>
                  <input
                    type="radio"
                    value={role}
                    name="behavior"
                    // checked={selectedFilters.includes(role)}
                    // onChange={() => handleFilterChange(role)}
                  />
                  <div className="flex-row align-center justify-start g-1">
                    <span
                      style={{
                        width: "0.9rem",
                        height: "0.9rem",
                        background: "red",
                      }}
                    ></span>
                    <span>{role}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <button className="w-full actionBtn">Update</button>
        </div>
      </SecondModal>
      <Helmet>
        <title>Students</title>
        <meta
          name="description"
          content="Download your students data for better visualization"
        />
      </Helmet>
      <PageHeader
        renderCustomElement={
          <StudentsPageHeaderCustom
            genderWaysFilter={genderWaysFilter}
            setGenderWaysFilter={setGenderWaysFilter}
          />
        }
      />
      <div className="classRepresentetiveSection">
        <button className="classRepresentativeFilterBtn">
          <div className="flex-col align-center justify-center g-05">
            <span>
              Class <br />
              representative
            </span>
            <div className="flex-row align-center justify-center g-05">
              <FilterIcon className="classRepresentativeFilterBtnIcon" />
              <span>Filter</span>
            </div>
          </div>
        </button>
        <div className="scrollableRepresentetiveSec flex-1 h-full">
          <div className="w-fit flex-row align-center justify-center g-05 h-full">
            {classRepresentativeData &&
              classRepresentativeData.map((data) => {
                return (
                  <div className="classRepresentativeCard" key={data._id}>
                    <p>{data.name}</p>
                    <p>
                      C-{data.class}, S-{data.section}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="scrollIndicatorForClassRepresentative">
          <ArrowIcon
            style={{
              transform: "rotate(-90deg)",
              stroke: "white",
              width: "1.2rem",
              height: "1.2rem",
            }}
          />
        </div>
      </div>
      <div className="studentListTableContainer">
        <CardHeader
          title="All Students data"
          actionBtn={
            <button className="actionBtn" onClick={() => exportToExcel()}>
              Download
            </button>
          }
        />
        <div className="studentDataTableContainer">
          <StudentsDataTable
            data={studentsData}
            thead={[
              "Name",
              "ID",
              "Class",
              "Reporting teacher",
              "Attendance",
              "Performance",
              "Last payment",
              "Subject strength",
              "Subject weakness",
              "Extra activity",
              "Behavior",
              "Achievements",
              "Like to do",
              "Address",
            ]}
          />
        </div>
      </div>
    </section>
  );
};

export default Body;
